export const SCOPED_INVITATION_SESSION_STORAGE_KEY = 'df8.scopedInvitationToken';
export const SCOPED_INVITATION_CONTINUATION_STORAGE_KEY = 'df8.scopedInvitationContinuation';

const VALID_CONTINUATION_VALUES = new Set(['login', 'signup', 'verify']);

let inMemoryScopedInvitationToken = null;
let inMemoryScopedInvitationContinuation = null;

const getSessionStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const normalizeToken = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

const normalizeContinuation = (value) => {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return VALID_CONTINUATION_VALUES.has(trimmed) ? trimmed : null;
};

export const setScopedInvitationToken = (token) => {
  const normalizedToken = normalizeToken(token);
  if (!normalizedToken) {
    clearScopedInvitationToken();
    return null;
  }

  inMemoryScopedInvitationToken = normalizedToken;
  getSessionStorage()?.setItem(SCOPED_INVITATION_SESSION_STORAGE_KEY, normalizedToken);
  return normalizedToken;
};

export const getScopedInvitationToken = () => {
  if (inMemoryScopedInvitationToken) {
    return inMemoryScopedInvitationToken;
  }

  const storedToken = normalizeToken(
    getSessionStorage()?.getItem(SCOPED_INVITATION_SESSION_STORAGE_KEY) ?? null,
  );

  if (!storedToken) {
    clearScopedInvitationToken();
    return null;
  }

  inMemoryScopedInvitationToken = storedToken;
  return storedToken;
};

export const clearScopedInvitationToken = () => {
  inMemoryScopedInvitationToken = null;
  getSessionStorage()?.removeItem(SCOPED_INVITATION_SESSION_STORAGE_KEY);
};

export const setScopedInvitationContinuation = (value) => {
  const normalizedContinuation = normalizeContinuation(value);
  if (!normalizedContinuation) {
    clearScopedInvitationContinuation();
    return null;
  }

  inMemoryScopedInvitationContinuation = normalizedContinuation;
  getSessionStorage()?.setItem(SCOPED_INVITATION_CONTINUATION_STORAGE_KEY, normalizedContinuation);
  return normalizedContinuation;
};

export const getScopedInvitationContinuation = () => {
  if (inMemoryScopedInvitationContinuation) {
    return inMemoryScopedInvitationContinuation;
  }

  const storedContinuation = normalizeContinuation(
    getSessionStorage()?.getItem(SCOPED_INVITATION_CONTINUATION_STORAGE_KEY) ?? null,
  );

  if (!storedContinuation) {
    clearScopedInvitationContinuation();
    return null;
  }

  inMemoryScopedInvitationContinuation = storedContinuation;
  return storedContinuation;
};

export const hasScopedInvitationContinuation = () => Boolean(getScopedInvitationContinuation());

export const clearScopedInvitationContinuation = () => {
  inMemoryScopedInvitationContinuation = null;
  getSessionStorage()?.removeItem(SCOPED_INVITATION_CONTINUATION_STORAGE_KEY);
};

export const clearScopedInvitationState = () => {
  clearScopedInvitationToken();
  clearScopedInvitationContinuation();
};

export const resetScopedInvitationSessionForTests = () => {
  inMemoryScopedInvitationToken = null;
  inMemoryScopedInvitationContinuation = null;
};
